import {
  ClusterOutlined,
  PartitionOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons";
import * as React from "react";
import { GroupType } from "src/types/ZGroup";

const iconMap: Record<GroupType, React.ReactNode> = {
  ByDictionary: <ClusterOutlined />,
  Mnemonic: <PartitionOutlined />,
};

export const getGroupTypeIcon = (group: GroupType) =>
  iconMap[group] ?? <QuestionCircleFilled />;
